export default function IconA() {
    return (
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 26.6665H66.4706C68.4198 26.6665 70 28.1589 70 29.9998V63.3332C70 65.1741 68.4198 66.6665 66.4706 66.6665H13.5294C11.5802 66.6665 10 65.1741 10 63.3332V26.6665Z"
                stroke="#FF8A00"
                strokeWidth="4"
            />
            <path d="M10 21.6665V26.6665" stroke="#FF8A00" strokeWidth="4" />
            <path d="M53.334 38.3335V46.6668" stroke="#FF8A00" strokeWidth="4" strokeLinecap="round" />
            <path
                d="M10 21.6665C10 18.9051 12.2386 16.6665 15 16.6665H50C51.841 16.6665 53.3333 18.1589 53.3333 19.9998V26.6665H15C12.2386 26.6665 10 24.4279 10 21.6665V21.6665Z"
                stroke="#FF8A00"
                strokeWidth="4"
            />
        </svg>
    );
}
